import {
  ActionReducerMapBuilder,
  createSlice,
  CreateSliceOptions
} from '@reduxjs/toolkit'

import { getAppVersionTraceActions } from './Actions'
import { SLICE_NAME } from './Selectors'
import { INITIAL_STATE, T_APP_CONFIG_REDUCER } from './Types'

const sliceOptions: CreateSliceOptions<T_APP_CONFIG_REDUCER> = {
  name: SLICE_NAME,
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: (
    builder: ActionReducerMapBuilder<T_APP_CONFIG_REDUCER>
  ): void => {
    builder.addCase(getAppVersionTraceActions.success, (state, action) => {
      const { payload } = action
      state.appVersion = payload
    })
  }
}

const slice = createSlice(sliceOptions)

export default slice.reducer
